import { Heart } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      style={{ background: "#4A1018", color: "#FBF5EA" }}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12 py-24 md:py-32 text-center">
        <p className="overline" style={{ color: "#E8902A" }}>
          <span className="divider-line mr-4" style={{ background: "#E8902A" }} />
          With Gratitude
          <span className="divider-line ml-4" style={{ background: "#E8902A" }} />
        </p>

        <h2 className="font-serif-wb mt-10 text-6xl sm:text-7xl lg:text-8xl tracking-tighter">
          Thank <span className="italic" style={{ color: "#E8902A" }}>you.</span>
        </h2>

        <p className="mt-10 max-w-xl mx-auto text-base leading-relaxed" style={{ color: "#e8d9b8" }}>
          For your love, your blessings, and for being part of our story. We
          cannot wait to see you in June.
        </p>

        <p className="mt-16 font-serif-wb text-2xl italic" style={{ color: "#E8902A" }}>
          Varsha &amp; Parag
        </p>
        <p className="mt-2 overline" style={{ color: "#C9A646" }}>
          June 24 · 2026 · Bhandara
        </p>

        <div className="mt-20 pt-10 border-t border-[#6a242f] flex flex-col sm:flex-row items-center justify-between gap-4 text-xs" style={{ color: "#b8a989" }}>
          <span>© 2026 Varsha &amp; Parag</span>
          <span className="inline-flex items-center gap-2">
            Made with <Heart size={12} style={{ color: "#E8902A" }} fill="#E8902A" /> for our families
          </span>
        </div>
      </div>
    </footer>
  );
}
